import HotelStrategyDetailBaseRoute from 'lumen/routes/hotel/strategy/detail-base';
import { TYPE_ID_BEST_FLEX } from 'lumen/utils/constants/rate-strategy-constants';

export default class HotelStrategyCancellationRoute extends HotelStrategyDetailBaseRoute {
  type = TYPE_ID_BEST_FLEX;
}
